module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"subtitle":"- PRODUCTS FOR YOU","relatedProducts":"RELATED PRODUCTS"},"ar":{"subtitle":"- منتجات لك","relatedProducts":"منتجات ذات صله"}}')
  delete Component.options._Ctor
}
